<div class="market-history">
  <ul class="nav nav-pills" role="tablist">
    <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;" *ngIf="!reuters"></i>

    <li class="nav-item">
      <a class="nav-link active" data-toggle="pill" (click)="toggleOrderView(false)" role="tab" aria-selected="false">
        <h6>{{"price"|translate}}</h6>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link " data-toggle="pill" (click)="toggleOrderView(true)" role="tab" aria-selected="true">
        <h6>{{"order"|translate}}</h6>
      </a>
    </li>
    <span class="widget-reuters" container="body" matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip" *ngIf="reuters != null">
      {{reuters}}
    </span>
    <!-- <span class="heading align-items-center" *ngIf="reuters == null" style="background:#2d3034;padding: 5px; border-radius: 5px;">
      <mat-icon>link</mat-icon>
    </span> -->
  </ul>
  <div id="recent-trades">
    <table class="table" *ngIf="isOrder">
      <thead>
        <tr style="padding-inline-end: 10px;">
          <th>{{"price"|translate}}</th>
          <th>{{"qty"|translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="companyDepth != null && companyDepth.bids.length>0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.bids">
          <td class="green">{{depth.ORDER_PRICE}}</td>
          <td>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</td>
        </tr>
      </tbody>
      <tbody *ngIf="companyDepth!=null && companyDepth.bids.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> No Bids </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>

      <tbody *ngIf="!companyDepth && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
    </table>

    <table class="table" *ngIf="!isOrder">
      <thead>
        <tr style="padding-inline-end: 10px;">
          <th>#</th>
          <th style="min-width: 80px; max-width: 80px;">{{"price"|translate}}</th>
          <th style="min-width: 80px; max-width: 80px;">{{"qty"|translate}}</th>
          <!-- <th>Total(ETH)</th> -->
        </tr>
      </thead>
      <tbody *ngIf="companyDepth != null && companyDepth.bidsPerPrice.length > 0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.bidsPerPrice" style="width: 100%;">
          <td>
            {{depth.split}}
          </td>
          <td class="green" style="min-width: 80px; max-width: 80px;text-align-last: start !important;">
            {{depth.ORDER_PRICE}}
          </td>
          <td style="min-width: 80px; max-width: 80px;">
            {{depth.VOLUME_TRADED | number: "1.0":"en-US"}}
          </td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="!companyDepth && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
    </table>
  </div>
</div>
